/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useEffect, useMemo } from "react";
import { usePartners } from "../../store/usePartners";
import { PartnersTable } from "./PartnersTable";

function PartnersScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const { allPartners, getAllPartners } = usePartners();

  /** Effects */
  useEffect(() => {
    getAllPartners(1, 1000);
  }, []);

  // Carriers are listed on their own page, and here only once an admin shows
  // one in the app, so a tenant whose only partners are hidden carriers should
  // still read as empty here.
  const ordinaryCount = useMemo(
    () =>
      (allPartners ?? []).filter(
        (partner) => !partner?.isCourier || partner?.showInApp
      ).length,
    [allPartners]
  );

  /** Callbacks */
  const addPartner = () => navigate(`/add-partner`);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-5 sm:mb-11">
          Partners
        </h1>
        <PrimaryButton label="Add new" onClick={addPartner} className="h-10" />
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!ordinaryCount ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Partner created yet.
          </p>
        ) : (
          <PartnersTable />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(PartnersScreen);
